import React from 'react'
import Image from 'next/image'

import {useHasBrandHeartIcon} from './useHasBrandHeartIcon'
import vioHeartIcon from './vio-price-watch-color-heart.svg'

interface BrandHeartIconProps {
  /** 48 on the AP card, 64 on the SUSI overlays. */
  size?: number
  className?: string
}

export const BrandHeartIcon = ({size = 48, className}: BrandHeartIconProps) => {
  const hasBrandHeartIcon = useHasBrandHeartIcon()

  if (!hasBrandHeartIcon) return null

  return (
    <Image
      className={className}
      src={vioHeartIcon}
      alt=""
      aria-hidden
      width={size}
      height={size}
    />
  )
}
